import { digitalKhata } from './api';

export const QUEUE_KEY = 'mandispot_khata_pending_v1';
export const QUEUE_EVENT = 'mandispot:khata-queue';
export const RECEIPTS_EVENT = 'mandispot:khata-receipts';
const LAST_SYNC_KEY = 'mandispot_khata_last_sync';

export const queueGet = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch { return []; }
};
export const queueSet = (list) => {
  try { localStorage.setItem(QUEUE_KEY, JSON.stringify(list)); } catch { /* quota */ }
  window.dispatchEvent(new CustomEvent(QUEUE_EVENT, { detail: list.length }));
};
export const lastSyncAt = () => localStorage.getItem(LAST_SYNC_KEY);

const SENDERS = {
  repay: (p) => digitalKhata.repay(p),
  debit: (p) => digitalKhata.manualDebit(p),
  trust: (p) => digitalKhata.trust(p),
};

let flushing = null;

// Sends queued offline entries one by one; failed ones stay queued. Single-flight.
export function flushKhataQueue() {
  if (flushing) return flushing;
  flushing = (async () => {
    const q = queueGet();
    if (!q.length) return { sent: 0, remaining: [] };
    const remaining = [];
    const receipts = [];
    for (const item of q) {
      try {
        const res = await SENDERS[item.kind](item.payload);
        if (res?.row && item.kind !== 'trust') receipts.push({ row: res.row, recordedAt: item.at ? new Date(item.at).toISOString() : null });
      } catch { remaining.push(item); }
    }
    queueSet(remaining);
    if (receipts.length) window.dispatchEvent(new CustomEvent(RECEIPTS_EVENT, { detail: receipts }));
    if (q.length > remaining.length) localStorage.setItem(LAST_SYNC_KEY, new Date().toISOString());
    return { sent: q.length - remaining.length, remaining };
  })().finally(() => { flushing = null; });
  return flushing;
}
